// Blind Barrels – make included items display as $0.00 on cart + drawer
// No extra /cart.js calls, no multi-second delay.
//
// ┌─────────────────────────────────────────────────────────────────┐
// │ QUARTERLY UPDATE REQUIRED                                      │
// │                                                                │
// │ When new variant IDs are created in Shopify admin, update the  │
// │ constants below. See _specs/021-q1-2026-march-release.md for   │
// │ the full checklist and previous quarter IDs.                   │
// │                                                                │
// │ DO NOT remove old IDs until verified the new ones work.        │
// │                                                                │
// │ After updating, test:                                          │
// │   1. Add quarterly sub → glass auto-added at $0?              │
// │   2. Add annual sub → 4-glass auto-added at $0?               │
// │   3. Remove subscription → included items removed?            │
// │   4. Blocked variants → cannot add to cart?                   │
// └─────────────────────────────────────────────────────────────────┘

(function () {
  if (window.BlindBarrelsCartOverrideInit) return;
  window.BlindBarrelsCartOverrideInit = true;

  // Variant IDs — reads from central config with hardcoded fallbacks.
  // Primary source: window.bbVariantConfig (set by snippets/bb-variant-config.liquid)
  // See _specs/026-p1-high-priority-fixes.md (Issue #20)
  var cfg = window.bbVariantConfig || {};
  const ANNUAL_SUB      = cfg.annualSub      || 44499268403407;
  const QUARTERLY_SUB   = cfg.quarterlySub   || 44491378622671;
  const ANNUAL_GLASS    = cfg.annualGlasses  || 44688158589135;
  const QUARTERLY_GLASS = cfg.quarterlyGlass || 44675174301903;
  const BONUS_BOX       = cfg.bonusBox       || 44675171680463;

  // Reference (retail) value in cents per included variant.
  // Used to render a struck-through "would-have-cost" price in the cart drawer
  // so customers see the savings instead of a blank/$0 cell.
  // (Bobby ask 2026-05-24 — drawer only; legal copy = "Included", never "Free".)
  const INCLUDED_REFERENCE_VALUE = {
    [ANNUAL_GLASS]:    25000, // 5th Bonus Kit + Custom Flight Board + 4 Tasting Glasses → $250
    [QUARTERLY_GLASS]:  2000, // single tasting glass → $20
    [BONUS_BOX]:        9000  // standalone bonus box → $90
  };

  function formatMoney(cents) {
    try {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, "{{ shop.money_format | escape }}");
      }
    } catch (e) {
      console.warn('Shopify.formatMoney not available, falling back.', e);
    }
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  function formatZero() {
    return formatMoney(0);
  }

  function isInDrawer(row) {
    return !!row.closest('#CartDrawer-CartItems, cart-drawer');
  }

  function getVariantIdFromRow(row) {
    const input = row.querySelector('input[data-quantity-variant-id]');
    if (!input) return null;
    const raw = input.getAttribute('data-quantity-variant-id');
    const id = parseInt(raw, 10);
    return isNaN(id) ? null : id;
  }

  function computeSubscriptionFlags(rows) {
    let hasAnnual = false;
    let hasQuarterly = false;

    rows.forEach(row => {
      const id = getVariantIdFromRow(row);
      if (!id) return;
      if (id === ANNUAL_SUB) hasAnnual = true;
      if (id === QUARTERLY_SUB) hasQuarterly = true;
    });

    return { hasAnnual, hasQuarterly };
  }

  function isIncludedVariant(variantId, flags) {
    if (!variantId) return false;

    if (variantId === ANNUAL_GLASS && flags.hasAnnual) return true;
    if (variantId === QUARTERLY_GLASS && flags.hasQuarterly) return true;
    if (variantId === BONUS_BOX && (flags.hasAnnual || flags.hasQuarterly)) return true;

    return false;
  }

  function applyIncludedOverrides() {
    const rows = Array.from(document.querySelectorAll('.cart-item'));
    if (!rows.length) return;

    const flags = computeSubscriptionFlags(rows);
    const zeroText = formatZero();

    rows.forEach(row => {
      const variantId = getVariantIdFromRow(row);
      const included  = isIncludedVariant(variantId, flags);

      row.classList.toggle('bb-included-item', included);

      if (!included) return;

      const inDrawer = isInDrawer(row);

      // In the cart DRAWER, Bold's per-line discount already renders the exact
      // "<s>$250.00</s> $0.00" treatment Bobby asked for (2026-05-24). Leave
      // Bold's native markup intact — CSS in cart-drawer-overrides.css styles it.
      // Do NOT strip .cart-item__discounted-prices and do NOT mutate .price--end.
      if (inDrawer) return;

      // Avoid hammering the same row over and over on the regular /cart page
      // (but let it run again if DOM is fully replaced)
      if (row.dataset.bbProcessed === 'true') return;
      row.dataset.bbProcessed = 'true';

      //
      // 1) Details column (title area) — /cart page only
      //
      const details = row.querySelector('.cart-item__details');
      if (details) {
        // Remove old crossed-out / sale price blocks in details
        details.querySelectorAll('.cart-item__discounted-prices').forEach(el => el.remove());

        // Find product-option nodes that actually look like prices and replace them
        details.querySelectorAll('.product-option').forEach(el => {
          const text = el.textContent.trim();
          // crude check: contains a currency symbol or looks like a number with decimals
          if (/[€£\$]/.test(text) || /^[0-9.,]+\s*(USD|EUR|GBP)?$/i.test(text)) {
            el.textContent = zeroText;
          }
        });
      }

      //
      // 2) Totals columns (mobile + desktop) — /cart page only
      //
      row.querySelectorAll('.cart-item__totals .cart-item__discounted-prices').forEach(el => el.remove());

      row.querySelectorAll('.cart-item__totals .price--end').forEach(el => {
        el.textContent = zeroText;
      });
    });
  }

  function setupObservers() {
    const containers = [
      document.querySelector('#main-cart-items'),
      document.querySelector('#CartDrawer-CartItems')
    ].filter(Boolean);

    if (!containers.length) {
      // Try again shortly; cart drawer can be injected after load
      setTimeout(setupObservers, 400);
      return;
    }

    const config = { childList: true, subtree: true };

    containers.forEach(container => {
      const observer = new MutationObserver(applyIncludedOverrides);
      observer.observe(container, config);
    });
  }

  function init() {
    applyIncludedOverrides();  // run once immediately
    setupObservers();          // then watch for cart changes
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
